import React from "react";
import { SovosButton } from "mosaic-react";

export const ActionButtonOutlined = ({ link, title, i18n, history, sx = {} }) => {
    return (
        <>
            <SovosButton
                size="small"
                onClick={() => {
                    history.push(`${link}`);
                }}
                children={i18n`${title}`}
                variant={"text"}
                sx={{ margin: "10px", ...sx }}
            ></SovosButton>
        </>
    );
};
